import { downloadFile } from "@afriannotate/app/utils/download";
import { apiUrl } from "@afriannotate/app/utils/jwt-storage";
import { cn } from "@afriannotate/app/utils/bem";
import { Button } from "@humansignal/ui";

/**
 * Export page card for projects that use <Preference>: the judgements, or
 * the majority per pair, as CSV.
 */
export const PreferenceExportCard = ({ project }) => {
  if (!/<\s*Preference\b/i.test(project?.label_config ?? "")) return null;
  const download = (rows) =>
    downloadFile(apiUrl(`/api/ext/preference/projects/${project.id}/judgements/?rows=${rows}`)).catch(() => {});
  const block = cn("export-page");

  return (
    <div className={block.elem("bundle").toClassName()}>
      <div className={block.elem("bundle-text").toClassName()}>
        <div className={block.elem("bundle-title").toClassName()}>Preference judgements</div>
        <div className={block.elem("bundle-body").toClassName()}>
          One row per judgement with the chosen and rejected options, or one row per pair with how the raters voted and
          which option won.
        </div>
      </div>
      <Button look="outlined" onClick={() => download("judgements")}>
        Judgements (CSV)
      </Button>
      <Button look="outlined" onClick={() => download("majority")}>
        Majority per pair (CSV)
      </Button>
    </div>
  );
};
